import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function blogPostsReducer(
  state = initialState.blogPost,
  action
) {
  switch (action.type) {
    case types.GET_BLOG_POST_BY_ID_SUCCESS:
    case types.GET_BLOG_POST_BY_SLUG_SUCCESS:
      return action.blogPost;
    case types.GET_BLOG_POST_BY_ID_REQUESTED:
    case types.GET_BLOG_POST_BY_ID_FAILED:
    case types.GET_BLOG_POST_BY_SLUG_REQUESTED:
    case types.GET_BLOG_POST_BY_SLUG_FAILED:
      return null;
    default:
      return state;
  }
}
